export default {
    url: 'blade-robotic-lawn-mower-checklist',
    include: ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'au'],
};
